import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe ({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform
{
  constructor(private sanitizer: DomSanitizer) {}

  public transform (htmlString: string): SafeHtml
  {
    return this.sanitizer.bypassSecurityTrustHtml(htmlString);
  }
}
